import { render, staticRenderFns } from "./SearchPanel.vue?vue&type=template&id=b326e8c0&scoped=true"
import script from "./SearchPanel.vue?vue&type=script&lang=ts"
export * from "./SearchPanel.vue?vue&type=script&lang=ts"
import style0 from "./SearchPanel.vue?vue&type=style&index=0&id=b326e8c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b326e8c0",
  null
  
)

export default component.exports